import classNames from 'classnames';
import Image from 'components/Image';
import Link from 'components/Link';
import xss from 'utils/xss';
import styles from './ImageBlock.module.scss';

function ImageBlock({
  ctaText,
  ctaUrl,
  headerContent,
  headerType,
  imageAltText,
  imageLink,
  imageUrl,
  linkText,
  linkUrl,
  textContent,
  useDarkText = true,
  useSmallHeading = false,
}) {
  const HeaderTag = headerType || 'h2';
  const showCtaDiv = ctaUrl || linkUrl;
  const linkStyle = ctaUrl
    ? `${styles.link} ${styles.link_padding}`
    : `${styles.link}`;

  const ctaStyle = linkUrl
    ? `${styles.cta} ${styles.margin_right}`
    : `${styles.cta}`;

  return (
    <section>
      <div className="d-flex flex-column h-100">
        {imageLink ? (
          <Link href={imageLink} aria-label={imageAltText} title={imageAltText}>
            <Image
              alt={imageAltText}
              className={styles.image}
              src={imageUrl}
              objectFit="contain"
              height={388.5}
              width={350}
            />
          </Link>
        ) : (
          <Image
            alt={imageAltText}
            className={styles.image}
            src={imageUrl}
            objectFit="contain"
            height={388.5}
            width={350}
          />
        )}
        <div
          className={classNames('d-flex flex-column', {
            [styles.darkText]: useDarkText,
            [styles.lightText]: !useDarkText,
          })}
        >
          {headerContent && (
            <div
              className={classNames(
                'font-frl fw-900 lh-1 mt-12',
                styles.header,
                {
                  [styles.small]: useSmallHeading,
                  [styles.large]: !useSmallHeading,
                }
              )}
            >
              <HeaderTag className="mb-0">{headerContent}</HeaderTag>
            </div>
          )}
          {textContent && (
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: xss(textContent) }}
              className={classNames('font-roboto fw-400 mt-8', styles.body)}
            />
          )}
          {showCtaDiv && (
            <div className={classNames('d-flex flex-row flex-wrap mt-8')}>
              {ctaUrl && (
                <Link
                  href={ctaUrl}
                  className={classNames(
                    'font-sofia fw-700 bg-secondary text-primary text-uppercase',
                    ctaStyle
                  )}
                >
                  {ctaText}
                </Link>
              )}
              {linkUrl && (
                <Link
                  href={linkUrl}
                  className={classNames('font-roboto fw-400', linkStyle, {
                    [styles.darkText]: useDarkText,
                    [styles.lightText]: !useDarkText,
                  })}
                >
                  {linkText}
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
  /* eslint-enable @next/next/no-img-element */
}

export default ImageBlock;
